<template>
  <div class="about">
    <div class="head">
      <p class="title">走进佳驰</p>
      <p class="sub-title">ENTERING JIACHI</p>
      <div class="children">
        <a class="one" href="#index" :class="{ active: opt == 0 }">关于佳驰</a>
        <a class="two" href="#history" :class="{ active: opt == 1 }"
          >发展大事记</a
        >
        <a class="three" href="#cooperative" :class="{ active: opt == 2 }"
          >佳驰荣誉</a
        >
      </div>
    </div>
    <index id="index" />
    <history id="history" />
    <cooperative id="cooperative" />
  </div>
</template>

<script>
import index from '@/components/about/index'
import history from '@/components/about/history'
import cooperative from '@/components/about/cooperative'

export default {
  components: {
    index,
    history,
    cooperative,
  },
  data() {
    return {
      opt: 0,
    }
  },
  created() {},
  mounted() {
    let index = document.getElementById('index').offsetTop
    let history = document.getElementById('history').offsetTop
    let cooperative = document.getElementById('cooperative').offsetTop
    window.addEventListener('scroll', (e) => {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop <= history) {
        this.opt = 0
      } else if (scrollTop >= history && scrollTop < cooperative) {
        this.opt = 1
      } else {
        this.opt = 2
      }
    })
  },
}
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 580px;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('../assets/img/about_banner.jpg');
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    font-size: 42px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }

  .sub-title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }

  .children {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    width: 100%;

    & > a {
      width: 200px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.78);
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      margin-right: 10px;
      cursor: pointer;
      text-decoration: none;
    }

    & > a.active {
      background: #126fcc;
      border: none;
    }
  }
}

.about {
}
</style>
